/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Go_Online_TitleInputs */



/**
* | output |
* | --- |
* | "Go Back Online?" |
*
* @param {Offline_Go_Online_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_go_online_title = /** @type {((inputs?: Offline_Go_Online_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Go_Online_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Revenir en ligne ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Volver en línea?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Voltar online?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tornare online?")
	return /** @type {LocalizedString} */ ("Go Back Online?")
});